import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';

export const useGetApplicantInfo = async (
  client: ApolloClient<NormalizedCacheObject>,
  applicationNo: string,
): Promise<any> => {
  const { data } = await client.query({
    query: gql`
      query ($filter: ApplicationFilter) {
        applications(filter: $filter) {
          _id
          applicationNo
          applicant {
            name {
              givenName
              surname
            }
          }
        }
      }
    `,
    variables: {
      filter: {
        applicationNo: {
          eq: applicationNo,
        },
      },
    },
    fetchPolicy: 'network-only',
  });

  return data?.applications?.[0];
};
